// JavaScript Document

function contentSlider(item) {

    let swiper;

    function init(item) {

        const swiperContainer = item.querySelector('.contentSwiper');

        const autoplay = swiperContainer.dataset.autoplay;

        let config = {
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: item.querySelector('.swiper-button-next'),
                prevEl: item.querySelector('.swiper-button-prev'), 
              },
        }


        if (autoplay) {

            config = { 
                autoplay: {
                    delay: autoplay,
                  },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: item.querySelector('.swiper-button-next'),
                    prevEl: item.querySelector('.swiper-button-prev'), 
                  },
            }

        } 


        swiper = new Swiper(swiperContainer, config);
    }
    function destroy() {
        if (swiper) {
            swiper.destroy();
        }
    }

    init(item);


    return {
        init : init,
        destroy : destroy
    }
}
